import styled from "styled-components";
import { NavLink as RouterLink } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

export const EllipsisContainer = styled.div<{ gridView: boolean }>`
  padding-left: ${props => (props.gridView ? "0px" : "11px")};
  padding-right: ${props => (props.gridView ? "0px" : "27px")};
  &:hover {
    cursor: pointer;
  }
`;

export const useStyles = makeStyles({
  root: {
    fontFamily: "'Open Sans', sans-serif",
    fontStyle: "normal",
    fontSize: "13px",
    fontWeight: "600" as any,
    lineHeight: "18px",
    letterSpacing: "0.2px",
    color: "#373F41",
    "&:hover": {
      color: "#098EDF",
      backgroundColor: "white",
    },
  },
});

export const Link = styled(RouterLink)`
  text-decoration: none;
  color: black;
`;
